import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ButtonComponent } from '../../boutons/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';


@Component({
  selector: 'app-report-bug-modal',
  imports: [
    ButtonComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
],
  templateUrl: './report-bug-modal.component.html',
  styleUrls: ['./report-bug-modal.component.scss', '../modal-styles.scss'],
})
export class ReportBugModalComponent {
  private http: HttpClient = inject(HttpClient);
  @Output() send: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  selectedFiles: File[] = [];

  reportForm: FormGroup = new FormGroup({
    subject: new FormControl('', [
      Validators.required,
      Validators.minLength(5),
    ]),
    issue: new FormControl('', [Validators.required, Validators.minLength(20)]),
  });

  onFileSelected(event: Event): void {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    if (target.files) {
      this.selectedFiles = Array.from(target.files);
    }
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  sendReport(): void {
    const url: string = `${environment.apiUrl}/report-issue`;
    const subject: string = this.reportForm.get('subject')?.value;
    const issue: string = this.reportForm.get('issue')?.value;
    this.http.post(url, { subject, issue }).subscribe({
      next: () => {
        this.send.emit();
      },
      error: (error) => {
        console.error('Error sending report', error);
      },
    });
  }
}
